<template>
  <div class="view contact" @click="toggleBubble($event, true)">
    <div class="banner">
      <div class="banner-background">
        <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="1014" viewBox="0 0 1900 1014"><defs><clipPath id="cb-a"><rect width="1900" height="1014" fill="none"/></clipPath><clipPath id="cb-b"><rect width="1900" height="1434" fill="#fff"/></clipPath><linearGradient id="cb-c" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><filter id="cb-e" x="-996.427" y="-1678.665" width="3024.699" height="3386.665" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="f"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter><filter id="cb-g" x="1604.653" y="329.564" width="85.847" height="85.847" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="h"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="h"/><feComposite in="SourceGraphic"/></filter><filter id="cb-i" x="1392.572" y="218.542" width="79.291" height="79.291" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="j"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="j"/><feComposite in="SourceGraphic"/></filter><filter id="cb-k" x="1433.652" y="308.5" width="100" height="100" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="l"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="l"/><feComposite in="SourceGraphic"/></filter><filter id="cb-m" x="877.5" y="687.5" width="73" height="73" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="n"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="n"/><feComposite in="SourceGraphic"/></filter><filter id="cb-o" x="815.5" y="648.5" width="91" height="91" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="p"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="p"/><feComposite in="SourceGraphic"/></filter></defs><g clip-path="url(#cb-a)"><g clip-path="url(#cb-b)"><path d="M1977.427,1116.172c1165.781,957.611,1148.792-250.375,1148.792,307.09s-711.452,947.233-1870.276,119.4S133.067,1553.6,133.067,996.131c0-453.773,533.073-700.764,1234.163-330.885,44.894,29.435-33.583,65.2-.347,90.884s53.651-7.522,125.973,2.4S1803.086,972.962,1977.427,1116.172Z" transform="translate(2429.218 840.273) rotate(158)" fill="url(#cb-c)"/><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#cb-e)"><path d="M1735.8,68.8c801.071,1055.6,737.631,167.285,847.943,542.018s-598.555,1220.746-1468.318,577.127S0,1399.183,0,965.77,934.723-986.8,1735.8,68.8Z" transform="translate(1621.74 -890.92) rotate(118)" fill="url(#cb-c)"/></g></g><g transform="translate(0 -100)"><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cb-g)"><circle cx="11" cy="11" r="11" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1641.75, 374.91)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cb-i)"><circle cx="8.5" cy="8.5" r="8.5" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1427.71, 257.33)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cb-k)"><circle cx="21.5" cy="21.5" r="21.5" transform="translate(1462.15 325)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cb-m)"><circle cx="8" cy="8" r="8" transform="translate(906 704)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cb-o)"><circle cx="17" cy="17" r="17" transform="translate(844 665)" fill="#00a1ed"/></g></g></g></svg>
      </div>
    </div>
    <div class="wrapper">
      <div class="page-title">
        <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="204.521" height="194.102" viewBox="0 0 204.521 194.102"><defs><filter id="cbb-a" x="0" y="9.704" width="190.693" height="184.399" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="cbb-c" x="38.748" y="0" width="72.765" height="72.764" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="cbb-e" x="131.757" y="93.26" width="72.765" height="72.764" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-280.119 516.148) rotate(-93)"><g transform="matrix(-0.05, 1, -1, -0.05, 500.78, 306.75)" filter="url(#cbb-a)"><path d="M71.59-7.113C113.855-11.551,96.762,21.832,120,60s-3.5,74.168-54.793,54.457S-4.125,96.16,15.039,60,29.324-2.676,71.59-7.113Z" transform="translate(42.72 160.76) rotate(-93)" fill="#00a1ed"/></g><g transform="matrix(-0.05, 1, -1, -0.05, 500.78, 306.75)" filter="url(#cbb-c)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(68.03 32.26) rotate(-93)" fill="#00a1ed"/></g><g transform="matrix(-0.05, 1, -1, -0.05, 500.78, 306.75)" filter="url(#cbb-e)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(161.04 125.52) rotate(-93)" fill="#00a1ed"/></g></g></svg>
        <h1>Get Support</h1>
        <p v-if="page" v-html="page.headline.replace(/\n/g, '<br>')"></p>
      </div>
    </div>
    <div class="form-container" :loading="loading">
      <div class="form-part success" v-if="success">
        <div class="part-title">
          <h3>Thank you!</h3>
          <p>We will review your application as soon as possible.</p>
        </div>
        <router-link to="/" class="btn blue">
          <span>Back to Home</span>
        </router-link>
      </div>
      <form @submit.prevent="register" v-else>
        <div class="form-part">
          <div class="part-step">Step 1</div>
          <div class="part-title">
            <h3>General Information</h3>
            <p>Add below general information about your company. <br>Note the following information will be publicly available on CAST’s website </p>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Organisation name</label>
              <input type="text" maxlength="40" v-model="registerModel.name" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Organisation type</label>
              <select v-model="registerModel.type" required>
                <option v-for="type in types" :key="type" :value="type">{{type}}</option>
              </select>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Year of creation</label>
              <input type="number" maxlength="4" min="1900" :max="new Date().getFullYear()" v-model="registerModel.year" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Address</label>
              <input type="text" maxlength="255" v-model="registerModel.address" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>City</label>
              <input type="text" maxlength="60" v-model="registerModel.city" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Country</label>
              <select v-model="registerModel.country" required>
                <option v-for="country in countries" :value="country.name" :key="country.code">{{country.name}}</option>
              </select>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Website</label>
              <input type="text" maxlength="255" v-model="registerModel.website" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Public contact email</label>
              <input type="email" maxlength="140" v-model="registerModel.email" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field autogrow">
              <label>Short description</label>
              <textarea maxlength="500" v-model="registerModel.description" required></textarea>
            </div>
          </div>
        </div>
        <div class="form-part">
          <div class="part-step">Step 2</div>
          <div class="part-title">
            <h3>Contact Details</h3>
            <p>Add below your contact details for our team to reach out. <br>Note the following information will be <b>not</b> be publicly available on CAST’s website </p>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Full name</label>
              <input type="text" maxlength="40" v-model="registerModel.contact_name" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Contact email</label>
              <input type="email" maxlength="255" v-model="registerModel.contact_email" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Phone</label>
              <input type="tel" pattern="[0-9-+ ]+" maxlength="20" v-model="registerModel.contact_phone" required>
            </div>
          </div>
        </div>
        <!-- <div class="form-part">
          <div class="part-step">Step 3</div>
          <div class="part-title">
            <h3>In-Depth</h3>
            <p>Add below your contact details for our team to reach out. <br>Note the following information will be <b>not</b> be publicly available on CAST’s website </p>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label @click="toggleBubble">Percentage of supported & active businesses <div class="info-bubble"><i class="fas fa-question-circle"></i><div class="info-text"><p>Percentage of total businesses currently supported that are active in the tourist industry</p></div></div></label>
              <select v-model="registerModel.businesses" required>
                <option value="<20%">Less than 20%</option>
                <option value=">50%">More than 50%</option>
                <option value="20%-50%">20% to 50%</option>
              </select>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label @click="toggleBubble">Provided Support <div class="info-bubble"><i class="fas fa-question-circle"></i><div class="info-text"><p>How many businesses active in the tourist industry have you supported over the last 3 years?</p></div></div></label>
              <input type="text" maxlength="40" v-model="registerModel.support" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label>Type of provided support</label>
              <input type="text" maxlength="255" v-model="registerModel.support_type" required>
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field">
              <label @click="toggleBubble">Funding <div class="info-bubble"><i class="fas fa-question-circle"></i><div class="info-text"><p>Sources of Funding for your Organisation</p></div></div></label>
              <input type="tel" maxlength="20" v-model="registerModel.funding">
            </div>
          </div>
          <div class="fieldgroup">
            <div class="field autogrow">
              <label @click="toggleBubble">Success stories <div class="info-bubble"><i class="fas fa-question-circle"></i><div class="info-text"><p>Up to three examples, name & website suffices</p></div></div></label>
              <textarea maxlength="500" v-model="registerModel.stories" required></textarea>
            </div>
          </div>
        </div> -->
        <div class="options">
          <div class="option">
            <CheckBox v-model="registerModel.newsletter" />
            <label>Subscribe to our newsletter and get the latest information about CAST</label>
          </div>
          <div class="option">
            <CheckBox v-model="registerModel.tos" />
            <label>I accept CAST <a href="/pages/terms-and-conditions" target="_blank">Terms & Conditions</a>, and <a href="/pages/privacy-policy" target="_blank">Data Protection Policy</a></label>
          </div>
        </div>
        <div class="error" v-if="error">{{error}}</div>
        <div class="buttons">
          <button type="submit" class="btn btn-ic" :loader="loading">
            <span>Get support</span>
            <i class="btn-icon fas fa-long-arrow-alt-right"></i>
            <i class="line1"></i>
            <i class="line2"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import CheckBox from '../components/CheckBox'
import autosize from 'autosize'

export default {
  name: 'register',
  components: {
    CheckBox
  },
  computed: {
    ...mapGetters({
      'functions': 'getFunctions',
      isMobile: 'getMobile',
      db: 'getDb'
    })
  },
  data() {
    return {
      loading: false,
      error: null,
      success: false,
      registerModel: {
        name: '',
        type: '',
        year: '',
        address: '',
        city: '',
        country: '',
        website: '',
        email: '',
        description: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        newsletter: false,
        tos: false
      },
      countries: require('@/assets/country-codes.json'),
      types: [
        'Incubator',
        'Investor Network',
        'Cluster',
        'Chamber of Commerce',
        'Accelerator',
        'Development Centre',
        'Association',
        'Startup',
        'SME',
        'Foundation',
        'BIC',
        'Non-profit'
      ],
      page: null
    }
  },
  methods: {
    toggleBubble(e, cancel) {
      if(this.isMobile) {
        e.stopPropagation()
        const opened = e.currentTarget.classList.contains('opened')
        this.$el.querySelectorAll('label.opened').forEach(label => label.classList.remove('opened'))
        if(!opened && !cancel) e.currentTarget.classList.add('opened')
      }
    },
    register() {
      if(this.loading) return
      if(!this.registerModel.tos) return this.error = "You need to agree to our terms and conditions to send your application."
      this.error = null
      this.loading = true
      this.functions.httpsCallable('register')(this.registerModel)
        .then(() => {
          this.loading = false
          this.registerModel = {
            name: '',
            type: '',
            year: '',
            address: '',
            city: '',
            country: '',
            website: '',
            email: '',
            description: '',
            contact_name: '',
            contact_email: '',
            contact_phone: '',
            businesses: '',
            support: '',
            support_type: '',
            funding: '',
            stories: '',
            newsletter: false,
            tos: false
          }
          this.$el.querySelectorAll('input, select, textarea').forEach(input => {
            input.parentNode.classList.remove('valid', 'invalid')
          })
          this.success = true
        })
        .catch(err => {
          this.loading = false
          this.error = err.message
        })
    }
  },
  mounted: function() {
    this.pageRef = this.db().collection('settings').doc('support').onSnapshot(page => {
      this.page = page.data()
      this.$store.commit('setPageLoading', false)
    })
    this.$nextTick(() => {
      this.$el.querySelectorAll('input, select, textarea').forEach(input => {
        if(input.tagName === "TEXTAREA") autosize(input)
        input.addEventListener('blur', () => {
          if(input.checkValidity()) {
            input.parentNode.classList.remove('invalid')
            input.parentNode.classList.add('valid')
          }
          else {
            input.parentNode.classList.remove('valid')
            input.parentNode.classList.add('invalid')
          }
        })
      })
    })
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
  }
}
</script>

<style scoped>
.contact {
  padding-top: 242px;
  /* background: url(../assets/cast_contact_banner.jpg) no-repeat center top/1920px auto; */
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.page-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title svg {
  position: absolute;
  top: -40px;
  left: 105px;
}

.page-title h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
  padding-top: 12px;
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 330px;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: #fff;
}

.form-container {
  position: relative;
  width: 1072px;
  max-width: calc(100% - 48px);
  margin: 92px auto 0;
}

.form-container .error {
  margin: 16px 0 0;
}

.form-container .btn[loader]:after {
  color: #F77E0B;
}

.form-container .form-part {
  background: #fff;
  margin-top: 75px;
  padding: 40px 60px;
  border-radius: 24px;
  box-shadow: 0 24px 36px rgba(94, 48, 4, 0.05);
}

.form-container .form-part.success {
  text-align: center;
  width: 480px;
  margin: auto;
  padding: 80px 40px;
  max-width: 100%;
}

.form-container .form-part .part-step {
  position: absolute;
  font-size: .72em;
  color: #00A1ED;
  text-transform: uppercase;
  letter-spacing: .58em;
  margin-top: 4px;
}

.form-container .form-part .part-step:after {
  content: '';
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 1px;
  background: #00A1ED;
  margin-left: 12px;
}

.form-container .form-part .part-title {
  text-align: center;
  margin-bottom: 50px;
}

.form-container .form-part .part-title h3 {
  font: bold 2.57em/1 'Butler';
  color: #00A1ED;
}

.form-container .form-part .part-title p {
  opacity: .5;
  font-size: .86em;
  font-style: italic;
}

.form-container .form-part .part-title p b {
  text-decoration: underline;
}

.form-container .form-part .field {
  position: relative;
  display: flex;
  margin-bottom: 24px;
}

.form-container .form-part .field:not(.autogrow) {
  align-items: center;
}

.form-container .form-part .field.valid:after,
.form-container .form-part .field.invalid:after {
  content: '';
  position: absolute;
  left: 770px;
  top: 0;
  bottom: 0;
  width: 12px;
  height: 12px;
  margin: auto;
  background: url(../assets/cast_ic_check.svg) no-repeat center/contain;
}

.form-container .form-part .field.invalid:after {
  background-image: url(../assets/cast_ic_error.svg);
}

.form-container .form-part .field input,
.form-container .form-part .field select,
.form-container .form-part .field textarea {
  width: 440px;
  border: none;
  border-bottom: 1px solid rgba(188, 188, 203, 0.46);
  height: 24px;
  font-size: .93em;
  color: #707070;
  letter-spacing: .2em;
  background-position: 97% center;
  flex-shrink: 0;
}

.form-container .form-part .field label {
  position: relative;
  width: 300px;
  text-align: right;
  padding: 0 16px;
  color: #00A1ED;
  font-weight: 400;
  letter-spacing: .2em;
}

.form-container .form-part .field.autogrow label {
  padding-top: 2px;
}

.form-container .form-part .field label .info-bubble {
  position: absolute;
  top: -12px;
  left: 100%;
  margin-left: -12px;
}

.form-container .form-part .field label .info-bubble i {
  font-size: .86rem;
}

.form-container .form-part .field label .info-bubble .info-text {
  position: absolute;
  left: -122px;
  top: 32px;
  width: 256px;
  padding: 20px 34px;
  font-size: .86rem;
  letter-spacing: normal;
  color: rgba(52, 52, 52, 0.5);
  text-align: left;
  pointer-events: none;
  opacity: 0;
  transform: translateY(10px);
  transition: all .16s ease-out;
  z-index: 2;
}

.form-container .form-part .field label .info-bubble .info-text p {
  position: relative;
  z-index: 3;
}

.form-container .form-part .field label .info-bubble .info-text:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 3px 9px rgba(94, 48, 4, 0.08);
  border-radius: 6px;
  z-index: 2;
}

.form-container .form-part .field label .info-bubble .info-text:after {
  content: '';
  position: absolute;
  width: 24px;
  height: 24px;
  background: #fff;
  z-index: 1;
  top: -12px;
  left: 0;
  right: 0;
  margin: auto;
  transform: rotateZ(45deg);
  box-shadow: 0 3px 9px rgba(94, 48, 4, 0.08);
}

.form-container .form-part .field label .info-bubble:hover .info-text,
.form-container .form-part .field label .info-bubble:hover:after,
.form-container .form-part .field label.opened .info-bubble .info-text,
.form-container .form-part .field label.opened .info-bubble:after {
  opacity: 1;
  transform: none;
}

.form-container .options {
  width: 670px;
  max-width: 100%;
  margin: 52px auto 0;
  font-size: .93em;
  letter-spacing: .2em;
}

.form-container .options .option {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: .93em;
}

.form-container .options .option:last-child {
  margin: 0;
}

.form-container .options a {
  text-decoration: underline;
}

.form-container .options label {
  margin-left: 16px;
}

.form-container .buttons {
  text-align: center;
  margin-top: 60px;
}

@media screen and (max-width: 1024px) {
  .page-title {
    color: #343434;
  }
  .page-title {
    display: block;
    padding: 0;
    text-align: center;
  }
  .page-title h1 {
    color: #00A1ED;
  }
  .page-title p {
    width: 420px;
    max-width: 100%;
    margin: auto;
  }
  .page-title p:before {
    position: relative;
    display: block;
    left: auto;
    margin: 16px auto 24px;
    background: #00A1ED;
  }
  .form-container,
  .form-container .form-part {
    margin-top: 48px;
  }
}

@media screen and (max-width: 930px) {
  .form-container .form-part .field.valid:after,
  .form-container .form-part .field.invalid:after {
    left: auto;
    right: -24px;
  }
}

@media screen and (max-width: 830px) {
  .form-container .form-part {
    padding: 40px;
  }
  .form-container .form-part .field input,
  .form-container .form-part .field select,
  .form-container .form-part .field textarea {
    width: 330px;
  }
}

@media screen and (max-width: 730px) {
  .form-container .form-part .part-step {
    position: relative;
    text-align: center;
  }
  .form-container .form-part .part-step:after {
    display: block;
    margin: 16px auto;
  }
}

@media screen and (max-width: 680px) {
  .contact {
    padding-top: 172px;
  }
  .form-container .form-part .field {
    display: block;
    margin-bottom: 48px;
  }
  .form-container .form-part .field label {
    display: block;
    text-align: left;
    width: auto;
    padding: 0;
  }
  .form-container .form-part .field input,
  .form-container .form-part .field select,
  .form-container .form-part .field textarea {
    width: 100%;
  }
  .form-container .form-part .field label .info-bubble .info-text {
    left: -282px;
    top: 50%;
    transform: translateY(-50%) !important;
  }
  .form-container .form-part .field label .info-bubble .info-text:after {
    top: 0;
    bottom: 0;
    right: -12px;
    left: auto;
    transform-origin: center center;
    box-shadow: none;
    border-top: 1px solid rgba(94, 48, 4, 0.05);
    border-right: 1px solid rgba(94, 48, 4, 0.05);
    z-index: 2;
  }
  .form-container .options {
    padding: 0 16px 0 32px;
  }
}
</style>

